import { render, staticRenderFns } from "./NvSection.vue?vue&type=template&id=5e70b48e&scoped=true&"
import script from "./NvSection.vue?vue&type=script&lang=js&"
export * from "./NvSection.vue?vue&type=script&lang=js&"
import style0 from "./NvSection.vue?vue&type=style&index=0&id=5e70b48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70b48e",
  null
  
)

export default component.exports